Auth = require 'db/auth'
BoardDisplayHelpers = require 'views/internal/board-display-helpers'
CardCopyView = require 'views/card/card-copy-view'
Confirm = require 'views/lib/confirm'
Dates = require 'lib/dates'
Dialog = require 'views/lib/dialog'
htmlEncode = require 'lib/util/text/html-encode'
PopOver = require 'views/lib/pop-over'
print = require('common/lib/util/print').default
Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'
track = require 'debug/track'
trackUe = require 'debug/trackUe'
_ = require 'underscore'

module.exports = class CardDetailMoreMenuView extends View
  viewTitleKey: 'share-and-more-ellipsis'

  events:
    'click .js-copy-card': 'copyCard'
    'click .js-delete': 'deleteCard'
    'click .js-short-url, .js-email, .js-embed': (e) -> @focusInput(e.currentTarget)
    'click .js-print': 'printModel'
    'click .js-export-json': 'exportJSON'

    'copy .js-short-url, .js-email, .js-embed': 'handleCopy'

  initialize: ->
    @listenTo @model, 'change:shortUrl', @render

  handleCopy: (e) ->
    switch
      when @$(e.currentTarget).hasClass('js-short-url')
        trackUe(
          "share and more menu", "copies", "short url", "", "", "",
          { cardid: @model.id, boardid: @model.getBoard().id, isLoggedIn: Auth.isLoggedIn() }
        )
      when @$(e.currentTarget).hasClass('js-email')
        trackUe(
          "share and more menu", "copies", "email address", "", "", "",
          { cardid: @model.id, boardid: @model.getBoard().id }
        )
      when @$(e.currentTarget).hasClass('js-embed')
        trackUe(
          "share and more menu", "copies", "embed code", "", "", "",
          { cardid: @model.id, boardid: @model.getBoard().id, isLoggedIn: Auth.isLoggedIn() }
        )

  copyCard: (e) ->
    track("Card Detail", "Card Copy Button", "Via More Menu")
    PopOver.pushView
      view: CardCopyView
      options: { @model, @modelCache }

    return

  focusInput: (el) ->
    @$(el).focus().select()

  getShortLinkData: ->
    if !@model.get('shortUrl')?
      @model.fetch({ fields: ['shortUrl'] })
    return

  deleteCardConfirm: (e) ->
    Confirm.pushView 'delete card',
      model: @model
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        Dialog.hide()
        @model.destroy()
        track("Card", "Delete")

    return

  render: ->
    data =
      dateAdded: Util.idToDate(@model.id).toISOString()
      jsonURL: "/#{ @model.typeName.toLowerCase() }/#{ @model.id }/#{ Util.makeSlug( @model.get('name') ) }.json"
      isLoggedIn: Auth.isLoggedIn()

    board = @model.getBoard()
    if board?
      _.extend data,
        pLevelClass: BoardDisplayHelpers.getPermLevelIconClassForBoard(board)
        pLevelAltText: BoardDisplayHelpers.getPermLevelAltTextForBoard(board)

    data.embed = [
      "<blockquote class=\"trello-card\">",
      "<a href=\"#{ htmlEncode(@model.get('url')) }\">#{ htmlEncode(@model.get('name')) }</a>",
      "</blockquote>",
      "<script src=\"#{ window.trelloForWebsites }/embed.min.js\"></script>"
    ].join('')

    @$el.html (
      templates.fillFromModel(
        'card_detail_more_menu',
        @model,
        data,
        { meta: templates.card_menu_meta }
      )
    )

    @getShortLinkData()
    Dates.update(@el)
    @focusInput @$('.js-autofocus')[0]
    @

  deleteCard: (e) ->
    Util.stop(e)
    track("Card Detail", "Delete Button", "Via More Menu")

    @deleteCardConfirm()

    return

  printModel: (e) ->
    Util.stop(e)
    PopOver.hide()

    track("Card Detail", "Print", "Via More Menu")

    @defer ->
      print()

    return

  exportJSON: (e) ->
    track("Card Detail", "Export JSON")



// WEBPACK FOOTER //
// ./app/scripts/views/card/card-detail-more-menu-view.coffee